export default class TranslationsProvider {
  constructor(settings) {
    this.translationsUrl = settings.translationsUrl
  }

  // RETURNS Promise
  getAllTranslations() {
    return this.sendGetRequest('GET', '')
  }

  // RETURNS Promise
  sendGetRequest(method, controller, parameters = {}) {
    var self = this
    return new Promise(function (resolve, reject) {
      var url = self.translationsUrl + controller
      for (var propertyName in parameters)
        url = url + '&' + propertyName + '=' + parameters[propertyName]

      var request = new XMLHttpRequest()
      request.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(request.response)
        } else {
          reject(new Error(`Request failed with status ${this.status}: ${request.statusText}`))
        }
      }
      request.onerror = function () {
        reject(new Error(`Request failed with status ${this.status}: ${request.statusText}`))
      }
      request.open(method, url, true)
      request.send()
    })
  }
}
